import { httpCreate } from './http';

const http = httpCreate('/srv/activity-upvote');

export const activityUpvote = {
	setActivetyUpvote(activityId, param) {
		return http.post(`/${activityId}`, param);
	},
	getActivetyUpvoteList(activityId, themeType) {
		return http.get(`list/${activityId}/${themeType}`);
	},
	resetActivityUpvote(activityId, themeType, sortNum) {
		return http.put(`/${activityId}/${themeType}/${sortNum}`);
	},
};
